/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const FormGrid = styled.div`
   display: grid;
   gap: 12px;
   /* minmax(0, 1fr), não 1fr: o mínimo de "1fr" é o min-content, e conteúdo
      não-encolhível (select com option longa) faria o grid estourar o
      container em layouts de largura dividida. Mínimo zero = campo encolhe e
      trunca. Sem efeito quando há espaço (2026-09-10). */
   grid-template-columns: repeat(12, minmax(0, 1fr));

   > * {
      grid-column: span 12;
   }

   @media (min-width: 768px) {
      gap: 14px;

      .col-2 {
         grid-column: span 2;
      }
      .col-3 {
         grid-column: span 3;
      }
      .col-4 {
         grid-column: span 4;
      }
      .col-6 {
         grid-column: span 6;
      }
      .col-8 {
         grid-column: span 8;
      }
      .col-9 {
         grid-column: span 9;
      }
   }
   @media (max-width: 900px) {
      grid-template-columns: 1fr;
   }
`;
